import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { space, height, width } from 'styled-system';

const VideoStyled = styled.div`
	${space};
	${height}
	${width}
    overflow: hidden;
	width: 100%;
	height: 100%;
	/* position: absolute; */
	display: block;

	${props => props.background && `
		position: absolute;
	`}

	video::-webkit-media-controls-overlay-play-button {
		display: none;
	}

	video {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center;
		display: block;

		&::-webkit-media-controls-overlay-play-button {
			display: none;
		}
	}
	video::-webkit-media-controls-overlay-play-button {
		display: none;
	}
`;

const Video = props => <VideoStyled {...props}>{props.children}</VideoStyled>;

Video.defaultProps = {
	src:
		'https://videos.ctfassets.net/v2bnirysgqi6/4QnhlpcnUWmW1C1jKeiHGu/007d9ee75403d37bdac5c9c9593ef343/polestar__1_.mp4'
};

export default Video;
